import type { Goal } from "@/app/goals/page"
import GoalCard from "./goal-card"
import AddGoalCard from "./add-goal-card"

interface ActiveGoalsProps {
  goals: Goal[]
  onDeleteGoal: (id: string) => void
  onEditGoal: (id: string, updatedGoal: Partial<Goal>) => void
}

export default function ActiveGoals({ goals, onDeleteGoal, onEditGoal }: ActiveGoalsProps) {
  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
      {goals.map((goal) => (
        <GoalCard key={goal.id} goal={goal} onDelete={onDeleteGoal} onEdit={onEditGoal} />
      ))}
      <AddGoalCard />
    </div>
  )
}
